module.exports = __webpack_public_path__ + "31edbc3b4f394f9616fd973d3f97c288.pdf";